// extracted by mini-css-extract-plugin
export default {"HelpPanel":"HelpPanel_HelpPanel__Ru5rO","CloseButton":"HelpPanel_CloseButton__FRBgp"};